$ringSectors: 30
$animDuration: 8s
$size: 200px
$ringRadius: $size/2.3
$ringSize: $ringRadius/4.5
$ringFontSize: $ringSize*1
$perspectiveSize: $size*4
$color: rgb($globalSettingsFontPrimary)

.spinner-overlay
    position: fixed
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    background: rgb($globalSettingsBackgroundTertiary)
    opacity: 0.8
    z-index: $indexCheckoutSpinner
    color: $color
    font-size: 14px

.info
    text-align: center
    font-weight: 700

.preloader
    animation: tiltSpin $animDuration linear infinite
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 0 auto
    height: $size
    width: $size
    perspective: $perspectiveSize
    display: flex
    &, &__ring
        transform-style: preserve-3d
    &__ring
        animation-name: spin
        animation-duration: $animDuration/2
        animation-timing-function: inherit
        animation-iteration-count: inherit
        font-size: $ringFontSize
        position: relative
        height: $ringSize
        width: $ringSize
        margin-bottom: 5px
        &:nth-child(even)
            animation-direction: reverse
    &__sector
        font-weight: 600
        position: absolute
        top: 0
        left: 0
        text-align: center
        text-transform: uppercase
        transform: translateZ($ringRadius)
        &, &:empty:before
            display: inline-block
            width: 100%
            height: 100%
        &:empty:before
            background: linear-gradient(transparent 45%,currentColor 55%, transparent 55%)
            content: ""
        @for $s from 2 through $ringSectors
            &:nth-child(#{$s})
                $angle: (360deg / $ringSectors) * ($s - 1)
                transform: rotateY($angle) translateZ($ringRadius)

/* Animations */
@keyframes tiltSpin
    from
        transform: rotateY(0) rotateX(30deg)
    to
        transform: rotateY(1turn) rotateX(30deg)

@keyframes spin
    from
        transform: rotateY(0)
    to
        transform: rotateY(1turn)
